import {useMessagePartText} from '@assistant-ui/react';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';

const MarkdownTextImpl = () => {
  const {text} = useMessagePartText();
  return (
    <MarkdownContainer>
      <Markdown content={text} shouldEjectFromTailwind={false} />
    </MarkdownContainer>
  );
};

export const MarkdownText = memo(MarkdownTextImpl);
